import {
  Document,
  Image,
  Line,
  Page,
  StyleSheet,
  Svg,
  Text,
  View,
} from "@react-pdf/renderer";
import logoH3K from "../../../logos/health3000_logo.png";
import { renderEUDate } from "../../../utils/utils";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 15,
    fontSize: 11,
  },

  pageNumbers: {
    position: "absolute",
    bottom: 10,
    right: 10,
    textAlign: "center",
  },

  // title view
  spaceBetween: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#3E3E3E",
  },

  h3k_logo_and_text: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    maxWidth: 250,
  },

  title_view: {
    display: "flex",
    flexDirection: "row",
  },
  title_view_text: {
    fontWeight: 900,
    fontSize: 15,
  },
  title_view_image: {
    width: 100,
  },

  // patient info
  patientInfo: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  patientInfo_title: {
    fontSize: 16,
    fontWeight: 900,
    marginBottom: 5,
  },
  patientInfo_text: {
    fontSize: 11,
    fontWeight: 700,
    marginLeft: 5,
  },

  // chart section
  chart_view: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  chart_title: {
    fontSize: 18,
    fontWeight: 900,
    marginBottom: 10,
  },
  chart: {
    alignSelf: "center",
    justifyContent: "center",
    width: 400,
    borderRadius: 8,
  },
  chart_big: {
    alignSelf: "center",
    justifyContent: "center",
    width: 400,
    borderRadius: 8,
  },
});

const clientHeaderPart = (logo) => {
  console.log(logo);
  if (logo == null || logo == undefined || (logo && logo.length == 0)) {
    return <></>;
  }

  return (
    <Image
      style={styles.title_view_image}
      src={
        logo == null || logo == undefined || (logo && logo.length == 0)
          ? ""
          : logo
      }
    />
  );
};

const MainHeader = ({ logoInfo, orgInfo }) => {
  let { includeH3K, logo, clientLogoPos } = logoInfo;
  if (
    clientLogoPos == null ||
    clientLogoPos == undefined ||
    (clientLogoPos && clientLogoPos.length == 0)
  ) {
    clientLogoPos = "DX";
  }

  let { org_name, address, cap, city } = orgInfo;

  let info = `${org_name}`;

  if (city && address && cap) {
    info += `- ${address} ${cap} - ${city}`;
  }
  let imgStyle = clientLogoPos == "DX" ? { marginLeft: 450 } : {};

  return (
    <View
      style={{ padding: 5, display: "flex", flexDirection: "column" }}
      fixed
    >
      <View style={imgStyle}>{clientHeaderPart(logo)}</View>

      <View style={{ justifyContent: "flex-start" }}>
        <Text>{info}</Text>
      </View>
    </View>
  );
};

const Divider = () => {
  return (
    <Svg height="10" width="575" fixed>
      <Line
        x1="0"
        y1="5"
        x2="570"
        y2="5"
        strokeWidth={0.5}
        stroke="rgb(0,0,0)"
      />
    </Svg>
  );
};

const MainFooter = ({ logoInfo }) => {
  let { includeH3K, logo, clientLogoPos } = logoInfo;
  console.log(includeH3K);
  console.log(clientLogoPos);
  if (includeH3K == null || includeH3K == undefined) {
    includeH3K = true;
  }

  return (
    <View style={styles.title_view} fixed>
      <View style={styles.spaceBetween}>
        <View style={styles.h3k_logo_and_text}>
          <Image
            style={[
              styles.title_view_image,
              !includeH3K && { display: "none" },
            ]}
            src={logoH3K}
          />
          <Text
            style={[styles.title_view_text, !includeH3K && { display: "none" }]}
          >
            {!includeH3K ? "" : "Instant Connection"}
          </Text>
        </View>
        <Text
          render={({ pageNumber, totalPages }) =>
            `Pag. ${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </View>
    </View>
  );
};

const PatientInfo = ({ patientInfo }) => {
  return (
    <View style={styles.patientInfo}>
      <Text style={styles.patientInfo_title}>Dettagli paziente:</Text>
      <Text style={styles.patientInfo_text}>
        Nome: {patientInfo.first_name}
      </Text>
      <Text style={styles.patientInfo_text}>
        Cognome: {patientInfo.last_name}
      </Text>
      <Text style={styles.patientInfo_text}>
        Data di Nascita: {renderEUDate(patientInfo.date_of_birth)}
      </Text>
      <Text style={styles.patientInfo_text}>
        {`Professionista Sanitario: ${patientInfo.doctor.last_name} ${patientInfo.doctor.first_name}`}
      </Text>
      <Text style={styles.patientInfo_text}>
        Intervallo di date: {patientInfo.startDate} - {patientInfo.endDate}
      </Text>
    </View>
  );
};

export const ReportPdfFull = ({
  patientInfo,
  logoInfo,
  orgInfo,
  chart_spo2,
  chart_pressure,
  chart_temperature,
  chart_omnia,
  chart_HR,
}) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <MainHeader logoInfo={logoInfo} orgInfo={orgInfo} />
        <PatientInfo patientInfo={patientInfo} />
        <View style={styles.chart_view} wrap={false}>
          <Text style={styles.chart_title}>Ossigenazione</Text>
          {chart_spo2 === null ? (
            <Text>Non ci sono dati</Text>
          ) : (
            <Image style={styles.chart} src={chart_spo2} />
          )}
        </View>
        <View style={styles.chart_view} wrap={false}>
          <Text style={styles.chart_title}>Pressione massima e minima</Text>
          {chart_pressure === null ? (
            <Text>Non ci sono dati</Text>
          ) : (
            <Image style={styles.chart} src={chart_pressure} />
          )}
        </View>
        <View style={styles.chart_view} wrap={false}>
          <Text style={styles.chart_title}>Frequenza Cardiaca</Text>
          {chart_HR === null ? (
            <Text>Non ci sono dati</Text>
          ) : (
            <Image style={styles.chart} src={chart_HR} />
          )}
        </View>
        <View style={styles.chart_view} wrap={false}>
          <Text style={styles.chart_title}>Temperatura</Text>
          {chart_temperature === null ? (
            <Text>Non ci sono dati</Text>
          ) : (
            <Image style={styles.chart} src={chart_temperature} />
          )}
        </View>
        <View style={styles.chart_view} wrap={false}>
          <Text style={styles.chart_title}>
            Ossigenazione, Pressione, Temperatura
          </Text>
          {chart_omnia === null ? (
            <Text>Non ci sono dati</Text>
          ) : (
            <Image style={styles.chart_big} src={chart_omnia} />
          )}
        </View>
        <Divider />
        <MainFooter logoInfo={logoInfo} />
      </Page>
    </Document>
  );
};
